import React, { useState } from 'react';
import { ChevronDownIcon, KeyIcon, UserCircle } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
type MenuItem = {
  label: string;
  submenu?: {
    label: string;
    path: string;
  }[];
};
const menuItems: MenuItem[] = [{
  label: 'Dashboard',
  submenu: [{
    label: 'Scouting',
    path: '/dashboard/scouting'
  }, {
    label: 'Platform',
    path: '/dashboard/platform'
  }]
}, {
  label: 'Players',
  submenu: [{
    label: 'All',
    path: '/players/all'
  }, {
    label: 'My Favourite',
    path: '/players/favorites'
  }, {
    label: 'My Searches',
    path: '/players/searches'
  }]
}, {
  label: 'Teams',
  submenu: [{
    label: 'All',
    path: '/teams/all'
  }, {
    label: 'My Team',
    path: '/teams/my-team'
  }, {
    label: 'My Favourite',
    path: '/teams/favorites'
  }]
}, {
  label: 'Matches',
  submenu: [{
    label: 'Table',
    path: '/matches/table'
  }, {
    label: 'Calendar',
    path: '/matches/calendar'
  }]
}, {
  label: 'Reports',
  submenu: [{
    label: 'TBD',
    path: '/reports'
  }]
}, {
  label: 'AI',
  submenu: [{
    label: 'TBD',
    path: '/ai'
  }]
}];
const Navigation = () => {
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const location = useLocation();
  const isActiveRoute = (item: MenuItem) => {
    return item.submenu?.some(subItem => location.pathname.startsWith(subItem.path));
  };
  return <div className="bg-white shadow-md" data-id="element-439" data-mp="1a7syss81ry5b">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-440" data-mp="1f5ui9e9dxzhb">
        <div className="flex items-center space-x-2 w-48" data-id="element-441" data-mp="1k3w9imgyt53v">
          <KeyIcon className="w-4 h-4 text-gray-500" data-id="element-442" data-mp="1k4e7bnj9zrdw" />
          <span className="text-sm text-gray-600" data-id="element-443" data-mp="uf7eeewnfcf8">Team Keys</span>
        </div>
        <div className="flex justify-center" data-id="element-444" data-mp="ph5w3w71rh4t">
          {menuItems.map(item => <div key={item.label} className="relative" onMouseEnter={() => setHoveredItem(item.label)} onMouseLeave={() => setHoveredItem(null)} data-id="element-445" data-mp="145tltlu7owmu">
              <button className={`px-4 py-3 flex items-center space-x-1 text-sm font-medium transition-colors
                  ${isActiveRoute(item) ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-700 hover:text-blue-600'}`} data-id="element-446" data-mp="1d68cl0py33xq">
                <span data-id="element-447" data-mp="1n2laybwfq5yt">{item.label}</span>
                {item.submenu && item.submenu.length > 0 && <ChevronDownIcon className="w-4 h-4" data-id="element-448" data-mp="1i3qmoufp7p7b" />}
              </button>
            </div>)}
        </div>
        <div className="flex items-center space-x-3 w-48 justify-end" data-id="element-449" data-mp="3jxpvn95clugu">
          <span className="text-sm font-medium text-gray-700" data-id="element-450" data-mp="1zex5bovnk5sg">John Smith</span>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center" data-id="element-451" data-mp="1zh05h1qirfaw">
            <UserCircle className="w-6 h-6 text-gray-600" data-id="element-452" data-mp="24g315vkm0967" />
          </div>
        </div>
      </div>
      {hoveredItem && menuItems.find(item => item.label === hoveredItem)?.submenu && <div className="absolute w-full bg-white border-t border-gray-100 shadow-sm" onMouseEnter={() => setHoveredItem(hoveredItem)} onMouseLeave={() => setHoveredItem(null)} data-id="element-453" data-mp="1um43b8rkjbk2">
            <div className="max-w-7xl mx-auto px-4 py-2" data-id="element-454" data-mp="16qhu7dfn67me">
              <div className="flex space-x-6" data-id="element-455" data-mp="16s2p545vbsks">
                {menuItems.find(item => item.label === hoveredItem)?.submenu?.map(subItem => <Link key={subItem.path} to={subItem.path} className="text-sm text-gray-700 hover:text-blue-600 transition-colors" data-id="element-456" data-mp="314sk7p7z37tr">
                      {subItem.label}
                    </Link>)}
              </div>
            </div>
          </div>}
    </div>;
};
export default Navigation;